export default __webpack_public_path__ + "static/media/cbbSala5A.905c126a.jpg";